var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudmoonfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2.051 0 40.293 26.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-cloud-moon-fill-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.555 28.32L25.059 28.32C30.586 28.32 34.922 24.062 34.922 18.594C34.922 13.516 31.113 9.609 25.996 9.043C23.77 5.625 20.156 3.613 16.074 3.613C10.391 3.613 5.527 7.656 4.414 13.105C1.699 14.453 0 17.168 0 20.332C0 25.02 3.574 28.32 8.555 28.32Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-cloud-moon-fill-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.184 18.34C39.355 18.34 42.344 13.633 42.344 10.938C42.344 10.273 42.051 9.785 41.523 9.785C40.703 9.785 39.687 10.84 37.441 10.84C33.73 10.84 31.445 8.652 31.445 5.293C31.445 3.223 32.598 1.738 32.598 0.84C32.598 0.332 32.266 0 31.641 0C28.672 0.039 24.062 3.672 24.062 9.238C24.062 14.336 28.086 18.34 33.184 18.34Z",
    fill: "#FFFFFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.555 26.27L25.059 26.27C29.453 26.27 32.871 22.93 32.871 18.594C32.871 14.297 29.395 11.055 24.766 11.016C23.008 7.656 19.785 5.664 16.074 5.664C11.035 5.664 6.758 9.531 6.27 14.57C3.691 15.371 2.051 17.598 2.051 20.332C2.051 23.848 4.687 26.27 8.555 26.27Z",
    fill: "#FFFFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudmoonfill);
export default __webpack_public_path__ + "static/media/cloud.moon.fill.36dbace6003d9ac1f9f127a90651d7ee.svg";
export { ForwardRef as ReactComponent };